import * as DxFilter from './_devexpressFilter';

export function StepDateInterval(direction: string) {
    CheckAndCorrectDateFilterValues();

    let fromDate: Date = new Date(Date.parse($('.dfflt-from').val().toString().replace(/\./g, '').replace(/ /g, '-')));
    let toDate: Date = new Date(Date.parse($('.dfflt-to').val().toString().replace(/\./g, '').replace(/ /g, '-')));
    let minDate = new Date('2013-01-01');
    let currDate: Date = new Date();
    let newFromDate: Date;
    let newToDate: Date;
    fromDate.setHours(0, 0, 0, 0);
    toDate.setHours(0, 0, 0, 0);
    minDate.setHours(0, 0, 0, 0);
    currDate.setHours(0, 0, 0, 0);

    // Get the date interval
    let dateDiffInDays: number = Math.round(Math.abs((toDate.valueOf() - fromDate.valueOf()) / (24 * 60 * 60 * 1000)));

    if (dateDiffInDays === 0) {
        dateDiffInDays = 1;
    }

    // Make sure that won't be lower than the birth of ÉTDR or higher than the current date
    if (direction === "back") {
        // Step back fromDate and toDate
        newFromDate = new Date(fromDate.setDate(fromDate.getDate() - dateDiffInDays));
        newToDate = new Date(toDate.setDate(toDate.getDate() - dateDiffInDays));

        // If the fromDate is the lowest possible, than no need to step back
        if (fromDate.getTime() < minDate.getTime()) {
            return;
        }

        fromDate = newFromDate.getTime() < minDate.getTime() ? minDate : newFromDate;
        toDate = newToDate.getTime() < minDate.getTime() ? minDate : newToDate;
    } else {
        // Step forward the fromDate and toDate
        newFromDate = new Date(fromDate.setDate(fromDate.getDate() + dateDiffInDays));
        newToDate = new Date(toDate.setDate(toDate.getDate() + dateDiffInDays));

        // If the toDate is the highest possible (current day), than no need to step back
        if (toDate.getTime() > currDate.getTime()) {
            return;
        }

        fromDate = newFromDate.getTime() > currDate.getTime() ? currDate : newFromDate;
        toDate = newToDate.getTime() > currDate.getTime() ? currDate : newToDate;
    }

    // Insert new values to the fields
    InsertDateValues(fromDate, toDate);
}

export function GetFormattedDateString(input: Date) {
    let year: string = ('0' + input.getFullYear().toString()).slice(-4);
    let month: string = ('0' + (input.getMonth() + 1).toString()).slice(-2);
    let day: string = ('0' + input.getDate().toString()).slice(-2);

    return year + ". " + month + ". " + day + ".";
}

export function InsertDateValues(fromDate: Date, toDate: Date) {
    $('.dfflt-from').val(GetFormattedDateString(fromDate));
    $('.dfflt-to').val(GetFormattedDateString(toDate));
}

function intervalBiggerThanConfigured(fromDate: string, toDate: string) {
    if (fromDate === '' || toDate === '') {
        return true;
    }

    let defaultInterval = $('#defaultDateInterval').val() as number;

    let fromDateTmp: number = createMilisecsFromCustomDateFormatString(fromDate);
    let toDateTmp: number = createMilisecsFromCustomDateFormatString(toDate);
    let timeDiff: number = Math.abs(toDateTmp - fromDateTmp);
    let dayDiff = Math.ceil(timeDiff / (1000 * 60 * 60 * 24));
    return dayDiff > defaultInterval ? true : false;
}

export function SetDateFilterSectionVisibility(visible: boolean) {
    let $filterSection: JQuery = $('#date-filter-area');

    // If not the right location, do nothing
    if ($filterSection.length === 0) {
        return;
    }

    let $fromDate: JQuery = $('.dfflt-from');
    let $toDate: JQuery = $('.dfflt-to');

    let isIntervalBiggerThanConfigured = intervalBiggerThanConfigured($fromDate.val().toString(), $toDate.val().toString());

    // Decide whether to show or hide the date range element
    if (visible) {

        // If one of the fields are empty, fill them with the defaults
        if ($fromDate.val() === '' || $toDate.val() === '' || isIntervalBiggerThanConfigured) {
            let dates: { fromDate: Date, toDate: Date } = GetDefaultDates();

            InsertDateValues(dates.fromDate, dates.toDate);
        }

        $filterSection.show();
    } else {

        $filterSection.hide();
    }
}

export function GetDefaultDates() {
    let defaultInterval = $('#defaultDateInterval').val() as number;

    type Dates = { fromDate: Date, toDate: Date };
    let fromDate: Date = new Date();
    let toDate: Date = new Date();

    toDate.setHours(0, 0, 0, 0);
    fromDate.setDate(toDate.getDate() - defaultInterval);

    return <Dates>{ fromDate: fromDate, toDate: toDate };
}

function createMilisecsFromCustomDateFormatString(dateString: string) {
    return Date.parse(dateString.replace(/\. ?/g, '-').slice(0, -1));
}

export function CheckAndCorrectDateFilterValues() {
    let $fromDate: JQuery = $('.dfflt-from');
    let fromDate: Date = new Date(createMilisecsFromCustomDateFormatString($fromDate.val().toString()));
    let minFromDate: Date = new Date('2013-01-01');
    minFromDate.setHours(0, 0, 0, 0);
    let $toDate: JQuery = $('.dfflt-to');
    let toDate: Date = new Date(createMilisecsFromCustomDateFormatString($toDate.val().toString()));
    let maxToDate: Date = new Date();
    maxToDate.setHours(0, 0, 0, 0);

    // When no date found, or the value is lower than lowest possible (2013-01-01), then set to 2013-01-01
    if ($fromDate.val() === '' || isNaN(fromDate.getTime()) || fromDate.getTime() < minFromDate.getTime()) {
        $fromDate.val(GetFormattedDateString(minFromDate));
        fromDate = minFromDate;
    }

    // When no date found, or the value is higher than the current date, set the current date.
    // On frontend use current date for this. 1 day will be added on backend to ensure that the whole
    // current day will be queried.
    if ($toDate.val() === '' || isNaN(toDate.getTime()) || toDate.getTime() > maxToDate.getTime()) {
        $toDate.val(GetFormattedDateString(maxToDate));
        toDate = maxToDate;
    }

    // If the fromDate is higher than toDate, swap those
    if (fromDate.getTime() > toDate.getTime()) {
        var tempVar = new Date(fromDate.valueOf());
        tempVar.setHours(0, 0, 0, 0);

        fromDate = new Date(toDate.valueOf());
        toDate = new Date(tempVar.valueOf());

        InsertDateValues(fromDate, toDate);
    }
}

jQuery(() => {
    $(document).on('click', '#step-back-date-interval', function (event) {
        StepDateInterval("back");
        $('#date-search-button').click();
    });

    $(document).on('click', '#step-forward-date-interval', function (event) {
        StepDateInterval("forward");
        $('#date-search-button').click();
    });

    $(document).on('click', '#datefilter-helper-toggle', function (event) {
        $('#datefilterhelperarea').toggle();
    });

    $(document).on('click', '#date-search-button', function (event: JQuery.TriggeredEvent) {
        DxFilter.RefreshGrid(event);
    });
});
